<template>
    <div>
        <form id="cnfmForm" name="cnfmForm" method="get" action="#">
        </form>
        <v-dialog/>
    </div>
</template>
<script>
import { getKMCDetailDecryptTPS} from '@/api/common'
export default {
    name: "ResultKmcTpsPop",
    data() {
        return {
            r_certNum:'',
            r_date:'',
            r_phoneNo:'',
            r_phoneCorp:'',
            r_birthDay:'',
            r_gender:'',
            r_nation:'',
            r_name:'',
            r_result:'',
            r_resultCode:'',
            r_check_1:'',
            r_check_2:'',
            r_check_3:'',
            rec_cert: '',
            termConditionCheckedStatus:'',
            r_Ci:''
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : KMC 결과 정보
         **/
        getInfo() {
            let rec_cert = this.$route.query.rec_cert
            let certNum = this.$route.query.certNum
            if(rec_cert === "" || certNum === ""){
                this.$modal.show('dialog', {
                    title: '본인 인증 실패',
                    text: '본인 인증을 실패했습니다.',
                    buttons: [{
                        title: '확인'
                    }]
                })
                return
            }
        getKMCDetailDecryptTPS({rec_cert: rec_cert, certNum: certNum}).then(res => {
                this.r_certNum = res.data.r_certNum
                this.r_date = res.data.r_date
                this.r_phoneNo = res.data.r_phoneNo
                this.r_phoneCorp = res.data.r_phoneCorp
                this.r_birthDay = res.data.r_birthDay
                this.r_gender = res.data.r_gender
                this.r_nation = res.data.r_nation
                this.r_name = res.data.r_name
                this.r_result = res.data.r_result
                this.r_resultCode = res.data.r_resultCode
                this.r_check_1 = res.data.r_check_1
                this.r_check_2 = res.data.r_check_2
                this.r_check_3 = res.data.r_check_3
                this.rec_cert = rec_cert
                this.r_Ci = res.data.r_Ci

                let returnValue = {
                    name: this.r_name,
                    phoneNo: this.r_phoneNo,
                    birthDay: this.r_birthDay.substr(2),
                    certNum: this.r_certNum,
                    rec_cert: this.rec_cert,
                    r_phoneCorp: this.r_phoneCorp,
                    r_Ci:this.r_Ci,
                    r_nation :this.r_nation,
                    r_gender: this.r_gender

                }
                if (this.r_result === "Y" ) {
                  //  alert("본인인증이 성공하였습니다.");

                    if(typeof(window.parent.cbAuthPop) == "function") {
                        window.parent.cbAuthPop(JSON.stringify(returnValue))
                    } else {
                        window.opener.cbAuthPop(JSON.stringify(returnValue))
                        window.close()
                    }

                    
                } else {
                    alert("인증처리중 오류가 발생했습니다[" + this.r_result  + "]");
                    window.close()
                }
            })
            // }).catch(error => {
            //     alert(error.message)
            // })
        },
    },
}
</script>

<style scoped>

</style>